import { call, put } from "@redux-saga/core/effects";
import {driverLogApi, driverLogCorrdinateApi, downloadChangeLocationHistoryApi, updateChangeLocationStatusApi} from "../../../Connections/APIs/DriverLog";
import {
    getDriverLogFailAction,
    getDriverLogSuccessAction,
    getDriverChangeCorrdinateAction,
    getDriverChangeCorrdinateSuccessAction,
    getDriverChangeCorrdinateFailAction,
    updateChangeLocationStatusFailAction,
    updateChangeLocationStatusSuccessAction,
    getPlanChangeStatusesExcelSuccessAction,
    getPlanChangeStatusesExcelFailAction
} from "../../Actions/DriverLog/Action";

export function* getDriverLogSaga(action) {
    try {
      const response = yield call(driverLogApi, action.data);
      yield put(getDriverLogSuccessAction(response.data));
    } catch (error) {
      yield put(getDriverLogFailAction(error));
    }
}

export function* getDriverLogCorrdinateSaga(action) {
    try {
        const response = yield call(driverLogCorrdinateApi, action.data);
        yield put(getDriverChangeCorrdinateSuccessAction(response.data));
    } catch (error) {
        yield put(getDriverChangeCorrdinateFailAction(error));
    }
}


export function* getPlanChangeStatusesExcelSaga() {
    try {
        const response = yield call(downloadChangeLocationHistoryApi);
        yield put(getPlanChangeStatusesExcelSuccessAction(response.data));
    } catch (error) {
        yield put(getPlanChangeStatusesExcelFailAction(error));
    }
}

export function* updateChangeLocationStatusSaga(action) {
    try {
        const response = yield call(updateChangeLocationStatusApi, action.data);
        yield put(updateChangeLocationStatusSuccessAction(response.data));
        yield put(getDriverChangeCorrdinateAction({pageNumber: 1_000, pageIndex: 1, onlyUnseen: true}));
    } catch (error) {
        yield put(updateChangeLocationStatusFailAction(error));
    }
}